import { useState, useEffect } from "react";
import { TextField, Button, Divider, Chip } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import mainStyles from "../Main.module.css";
import loadingImage from "../loading.gif";
import validator from "validator";
import api from "../../services/api";
import { useMyContext } from "../../store/ContextApi";
import { useDispatch, useSelector } from "react-redux";
import { getColors } from "../../State/Color/Action";
import { getCities } from "../../State/City/Action";
import { getMyWorkshops } from "../../State/Workshop/Action";
import { getBrands } from "../../State/Brand/Action";
import { getModelsByBrand } from "../../State/Model/Action";
import { registerUsedBike } from "../../State/UsedBike/Action";

export default function UsedBike() {
  const colors = useSelector((store) => store.colorResponse.colors);
  const brands = useSelector((store) => store.brandResponse.brands);
  const cities = useSelector((store) => store.cityResponse.cities);
  const models = useSelector((store) => store.modelResponse.models);
  const workshops = useSelector(
    (store) => store.workshopResponse.workshopPaginated.workshops
  );
  const bike = useSelector((store) => store.usedBikesResponse.bike);

  const [bikeId, setBikeId] = useState("");
  const [brandId, setBrandId] = useState();
  const [bikeModelId, setBikeModelId] = useState();
  const [color, setColor] = useState();
  const [purchaseYear, setPurchaseYear] = useState();
  const [runningKms, setRunningKms] = useState();
  const [sellerName, setSellerName] = useState();
  const [sellerMobile, setSellerMobile] = useState();
  const [sellerAddress, setSellerAddress] = useState();
  const [sellerCityId, setSellerCityId] = useState();
  const [price, setPrice] = useState();
  const [registrationNumber, setRegistrationNumber] = useState();
  const [description, setDescription] = useState();
  const [workshopId, setWorkshopId] = useState();

  const [imageStates, setImageStates] = useState({
    FRONT: {
      file: null,
      url: "",
      loading: false,
      uploaded: false,
      error: false,
    },
    TOP: { file: null, url: "", loading: false, uploaded: false, error: false },
    LEFT: {
      file: null,
      url: "",
      loading: false,
      uploaded: false,
      error: false,
    },
    RIGHT: {
      file: null,
      url: "",
      loading: false,
      uploaded: false,
      error: false,
    },
    BACK: {
      file: null,
      url: "",
      loading: false,
      uploaded: false,
      error: false,
    },
  });

  const [isSaved, setIsSaved] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true);

  const { isDealer } = useMyContext();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getColors());
    dispatch(getBrands());
    dispatch(getCities());
    dispatch(getMyWorkshops(0));
  }, []);

  useEffect(() => {
    if (bike) {
      onSuccessfulSave();
      resetForm();
    }
  }, [bike]);

  const loadModels = (e, brand) => {
    setBrandId(brand);
    dispatch(getModelsByBrand(brand));
  };

  const handleImageChange = (angle, file) => {
    if (!file) return;

    const newImageStates = { ...imageStates };
    newImageStates[angle].loading = true;
    setImageStates(newImageStates);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("imageAngle", angle);
    formData.append("bikeId", bikeId);

    api
      .post("/usedBikes/images", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        const updated = { ...imageStates };
        updated[angle] = {
          file: file,
          url: res.data.imageUrl,
          loading: false,
          uploaded: true,
          error: false,
        };
        setImageStates(updated);
        setBikeId(res.data.bikeId);
      })
      .catch(() => {
        const updated = { ...imageStates };
        updated[angle].loading = false;
        updated[angle].error = true;
        setImageStates(updated);
      });
  };

  const validatePhoneNumber = (number) => {
    const isValid = validator.isMobilePhone(number);
    setSellerMobile(number);
    setIsValidPhoneNumber(isValid);
  };

  const isValidForm = () => {
    setErrorMessage();
    if (!bikeId) {
      setErrorMessage("Bike Front image is required");
      return false;
    } else if (!brandId) {
      setErrorMessage("Brand is required");
      return false;
    } else if (!bikeModelId) {
      setErrorMessage("Bike Model is required");
      return false;
    } else if (!color) {
      setErrorMessage("Color is required");
      return false;
    } else if (!purchaseYear) {
      setErrorMessage("Purchase Year is required");
      return false;
    } else if (!sellerName) {
      setErrorMessage("Seller Name is required");
      return false;
    } else if (!sellerMobile) {
      setErrorMessage("Seller Mobile is required");
      return false;
    } else if (!sellerAddress) {
      setErrorMessage("Seller Address is required");
      return false;
    } else if (!sellerCityId) {
      setErrorMessage("Seller City is required");
      return false;
    } else if (!price) {
      setErrorMessage("Price is required");
      return false;
    } else if (!imageStates.FRONT.uploaded) {
      setErrorMessage("Front View Image is required");
      return false;
    } else if (!isValidPhoneNumber) {
      setErrorMessage("Phone number is invalid");
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const customerId = localStorage.getItem("userId");
    const usedBike = {
      customerId,
      brandId,
      bikeModelId,
      color,
      description,
      purchaseYear,
      runningKms,
      sellerName,
      sellerMobile,
      sellerAddress,
      sellerCityId,
      price,
      registrationNumber,
      bikeId,
      workshopId,
    };

    if (isValidForm()) {
      dispatch(registerUsedBike(usedBike));
    } else {
      setIsLoading(false);
    }
  };

  const onSuccessfulSave = () => {
    setIsSaved(true);
    setIsLoading(false);
  };

  const resetForm = () => {
    setBikeId("");
    setBrandId();
    setBikeModelId();
    setColor();
    setPurchaseYear();
    setRunningKms();
    setSellerName();
    setSellerMobile();
    setSellerAddress();
    setSellerCityId();
    setPrice();
    setRegistrationNumber();
    setDescription();
    setImageStates({
      FRONT: {
        file: null,
        url: "",
        loading: false,
        uploaded: false,
        error: false,
      },
      TOP: {
        file: null,
        url: "",
        loading: false,
        uploaded: false,
        error: false,
      },
      LEFT: {
        file: null,
        url: "",
        loading: false,
        uploaded: false,
        error: false,
      },
      RIGHT: {
        file: null,
        url: "",
        loading: false,
        uploaded: false,
        error: false,
      },
      BACK: {
        file: null,
        url: "",
        loading: false,
        uploaded: false,
        error: false,
      },
    });
    setIsValidPhoneNumber(true);
  };

  const years = Array.from({ length: 2025 - 2000 }, (_, i) => 2000 + i);

  return isLoading ? (
    <div className={mainStyles.loading}>
      <img src={loadingImage} alt="loading" />
    </div>
  ) : (
    <div>
      <header className="text-2xl font-bold text-white text-center bg-gradient-to-r from-blue-500 to-blue-700 py-4 shadow-lg rounded-md">
        Used Bike Registration
      </header>

      <div className="space-y-4 p-6 bg-white shadow-lg rounded-lg">
        {isDealer && (
          <div>
            <label className="block text-gray-700 font-semibold">
              Select Workshop
            </label>
            <select
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              onChange={(e) => setWorkshopId(e.target.value)}
            >
              <option>Select Workshop</option>
              {workshops?.map((workshop) => (
                <option key={workshop.workshopId} value={workshop.workshopId}>
                  {workshop.name}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <TextField
            className="w-full"
            variant="outlined"
            onChange={(e) => setSellerName(e.target.value)}
            label="Enter Seller Name"
          />

          <TextField
            className="w-full"
            type="tel"
            variant="outlined"
            onChange={(e) => validatePhoneNumber(e.target.value)}
            label="Enter Seller Mobile"
          />
        </div>

        <TextField
          className="w-full"
          onChange={(e) => setSellerAddress(e.target.value)}
          label="Enter Address"
          multiline
          rows={3}
          variant="outlined"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-gray-700 font-semibold">
              Select City
            </label>
            <select
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              onChange={(e) => setSellerCityId(e.target.value)}
            >
              <option>Select City</option>
              {cities.map((city) => (
                <option key={city.cityId} value={city.cityId}>
                  {city.cityName}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-gray-700 font-semibold">
              Select Brand
            </label>
            <select
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              onChange={(e) => loadModels(e, e.target.value)}
            >
              <option>Select Brand</option>
              {brands.map((brand) => (
                <option key={brand.brandId} value={brand.brandId}>
                  {brand.brandName}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-gray-700 font-semibold">
              Select Model
            </label>
            <select
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              onChange={(e) => setBikeModelId(e.target.value)}
            >
              <option>Select Model</option>
              {models.map((model) => (
                <option key={model.modelId} value={model.modelId}>
                  {model.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-gray-700 font-semibold">
              Select Color
            </label>
            <select
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              onChange={(e) => setColor(e.target.value)}
            >
              <option>Select Color</option>
              {colors.map((color) => (
                <option key={color} value={color}>
                  {color}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <TextField
            className="w-full"
            variant="outlined"
            onChange={(e) => setRegistrationNumber(e.target.value)}
            label="Enter Bike Number"
          />

          <TextField
            className="w-full"
            type="number"
            variant="outlined"
            onChange={(e) => setRunningKms(e.target.value)}
            label="Enter Running KMs"
          />

          <TextField
            className="w-full"
            type="number"
            variant="outlined"
            onChange={(e) => setPrice(e.target.value)}
            label="Enter Selling Price"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-semibold">
            Select Purchase Year
          </label>
          <select
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            onChange={(e) => setPurchaseYear(e.target.value)}
          >
            <option>Select Purchase Year</option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        <TextField
          className="w-full"
          onChange={(e) => setDescription(e.target.value)}
          label="Enter Remarks"
          multiline
          rows={3}
          variant="outlined"
        />
      </div>

      <div className="p-6 bg-white shadow-lg rounded-lg space-y-6">
        {["FRONT", "TOP", "LEFT", "RIGHT", "BACK"].map((angle) => {
          const imageState = imageStates[angle];
          return (
            <div
              key={angle}
              className="border border-gray-300 rounded-lg p-4 space-y-4"
            >
              <Divider>
                <Chip
                  label={`Bike ${angle} View`}
                  size="small"
                  className="text-lg font-semibold"
                />
              </Divider>

              <div className="flex flex-col items-center space-y-4">
                {imageState.url ? (
                  <img
                    src={imageState.url}
                    alt={angle}
                    className="rounded-lg border shadow-sm object-cover"
                    style={{ width: "150px", height: "150px" }}
                  />
                ) : (
                  <div className="w-40 h-40 flex items-center justify-center border border-dashed rounded-lg text-gray-400">
                    No Image
                  </div>
                )}

                {imageState.loading && (
                  <img
                    src={loadingImage}
                    className="w-10 h-10 animate-spin"
                    alt="loading"
                  />
                )}

                <Button
                  variant="contained"
                  component="label"
                  startIcon={<SaveIcon />}
                  className="bg-blue-600 hover:bg-blue-700"
                >
                  {imageState.uploaded ? "Replace Image" : "Upload Image"}
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={(e) =>
                      handleImageChange(angle, e.target.files[0])
                    }
                  />
                </Button>

                {imageState.uploaded && (
                  <p className="text-green-600 font-semibold">
                    Image uploaded successfully!
                  </p>
                )}
                {imageState.error && (
                  <p className="text-red-600 font-semibold">
                    Image upload failed. Try again.
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <Divider />

      <div className="text-center mt-2 mb-2">
        <Button
          onClick={handleSubmit}
          type="submit"
          variant="contained"
          startIcon={<SaveIcon />}
          className={mainStyles.component}
        >
          Save Bike
        </Button>
      </div>

      <div className={mainStyles.componentContainer}>
        {isSaved && (
          <p className={mainStyles.success}>Bike Saved Successfully</p>
        )}
        {errorMessage && <p className={mainStyles.error}>{errorMessage}</p>}
      </div>
    </div>
  );
}
